import { getRegisteredStage } from "../../content/customRegistry.js";
import { DEFAULT_STAGE_ID, getStageMap, isStageId } from "../../content/stages.js";
import { createInitialDeck } from "../deck/initialDeck.js";
import type { CardId, RunState } from "../types/index.js";

export type CreateRunInput = {
  seed?: number;
  stageId?: string;
  runId?: string;
  bringInCardId?: CardId;
};

export function createRun(input: CreateRunInput = {}): RunState {
  const seed = input.seed ?? 1;
  const stageId = isStageId(input.stageId) || getRegisteredStage(input.stageId)
    ? String(input.stageId)
    : DEFAULT_STAGE_ID;
  const nodes = getStageMap(stageId);
  const start = nodes.start ?? Object.values(nodes).find((node) => node.kind === "start");
  const deckResult = createInitialDeck({
    rngState: seed,
    nextCardSequence: 1,
    stageId,
    bringInCardId: input.bringInCardId,
  });

  return {
    schemaVersion: 1,
    runId: input.runId ?? `run-${seed}`,
    stageId,
    bringInCardId: input.bringInCardId ?? null,
    initialSeed: seed,
    // 通常ランではseedは開始時刻。明示seedのリプレイでも状態を再現可能にする。
    startedAt: seed,
    rngState: deckResult.rngState,
    nextCardSequence: deckResult.nextCardSequence,
    fatigue: 0,
    organizations: [],
    deck: deckResult.deck,
    hand: [],
    discard: [],
    inPlay: [],
    aside: [],
    currentNodeId: start?.id ?? "start",
    availableNodeIds: [...(start?.next ?? [])],
    clearedNodeIds: [],
    activeCase: null,
    energy: 0,
    block: 0,
    pendingChoice: null,
    pendingRepeat: null,
    hasSeenPhaseTutorial: false,
    rewardCardIds: [],
    organizationChoices: [],
    log: [],
    outcome: null,
    nextCaseModifiers: { deadline: 0, required: 0, energy: 0 },
  };
}
